import React, { useContext, useState, useEffect } from "react";
import Chart from "chart.js/auto";
import { ArcElement } from "chart.js";
import {
  Box,
  Button,
  Heading,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  HStack,
  useRadioGroup,
  Text,
  Flex,
  Divider,
  Select,
  Grid,
  SimpleGrid,
  Image,
} from "@chakra-ui/react";
import { HomeContext } from "../../../context/HomeContext";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Pie, Doughnut } from "react-chartjs-2";
import IconCard from "../../layouts/IconCard";
import Counter from "../../../assets/Counter";
import Picto1 from "./picto7/Picto1.png";
import Picto2 from "./picto7/Picto2.png";
import Picto3 from "./picto7/Picto3.png";
import Picto4 from "./picto7/Picto4.png";
import Picto5 from "./picto7/Picto5.png";
import Picto6 from "./picto7/Picto6.png";
import Picto7 from "./picto7/Picto7.png";
import Picto8 from "./picto7/Picto8.png";
// import Picto9 from "./picto7/Picto9.png";
import RadioCard from "../../layouts/RadioCard";

const ConsoCard = ({ title, amount, icon, bgColor }) => {

  return (
    <Box
      bgColor={"F7F9FE"}
      w={["248px", "248px", "208px", "248px"]}
      h={"235px"}
    >
      <Box
        display={"flex"}
        w={["248px", "248px", "208px", "248px"]}
        mr={"20px"}
        h={"235px"}
        flexDirection={"column"}
        alignItems={"center"}
        gap={"10px"}
        borderRadius={"20px"}
        padding={"10px, 10px, 20px, 10px"}
        borderWidth={"1px"}
      >
        <Box
          my={"10px"}
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderRadius="18px"
          w={["200px", "200px", "188px", "228px"]}
          h="123px"
          bgColor="#F7F9FE"
        >
          <Image boxSize="40px" src={icon} alt={`Pictogramme de ${title}`} />
        </Box>
        <Text color="#8C8C8C" fontWeight="semibold" fontSize="sm">
          {title}
        </Text>
        <Text color="gray.700" fontSize="lg" fontWeight="bold" my="2">
          {`${amount}€`}
        </Text>
      </Box>
    </Box>
  );
};

const StepSeven = ({ onNext, onBack }) => {
  const [formData, setFormData, defaultFormData] = useContext(HomeContext);

  const [chartData, setChartData] = useState(null);
  const [isButtonVisible, setIsButtonVisible] = useState(true);
  const [showBaremeResult, setShowBaremeResult] = useState(false);
  console.log(formData)


  useEffect(() => {
    Chart.register(ArcElement, ChartDataLabels);
  }, []);
  const calculateDepenseECS = () => {
    if (formData.energieType === "Chaudiere") {
      return formData.factureSecondaire * 0.3;
    } else if (formData.sourceType === "ELECTRICITE") {
      return formData.factureElectricite * 0.3;
    }
    return formData.factureElectricite * 0.6;
  };


  function calculateDepenseChauffage() {
    if (formData.sourceType === "ELECTRICITE") {
      return formData.factureElectricite * 0.6;
    } else if (formData.energieType === "Chaudiere") {
      return formData.factureSecondaire * 0.7;
    } else {
      return formData.factureSecondaire;
    }
  }


  formData.depenseChauffage = calculateDepenseChauffage(formData);

  formData.depenseECS = calculateDepenseECS();

    const calculateDepensesElec = () => {
      const totalDepenses = formData.factureElectricite + formData.factureSecondaire - formData.depenseChauffage - formData.depenseECS;
      
      formData.depenseMenager = totalDepenses * 0.9;
      formData.depenseEclairage = totalDepenses * 0.1;
    };
    
    // Appeler cette fonction au moment approprié, par exemple lors de la soumission d'un formulaire ou après la saisie des données pertinentes.
    calculateDepensesElec();
    

  const options = {
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        color: "black",
        font: {
        weight: 'bold', // Mettre les labels en gras
      },
        anchor: "end",
        align: "start",
        formatter: (value, context) => {
          let sum = 0;
          let dataArr = context.chart.data.datasets[0].data;
          dataArr.map((data) => {
            sum += data;
          });
          let percentage = ((value * 100) / sum).toFixed(0) + "%";
          return percentage;
        },
      },
    },
  };

  const generateChartData = () => {
    if (formData) {
      const newData = {
        datasets: [
          {
            label: "Répartition de votre consommation énergétique",
            data: [
              formData.depenseChauffage, // Utilisez la valeur calculée pour le chauffage
              formData.depenseECS, // Utilisez la valeur calculée pour l'eau chaude sanitaire
              formData.depenseMenager, // Utilisez la valeur calculée pour les appareils électriques
              formData.depenseEclairage, // Remplacez par la valeur calculée pour l'éclairage quand elle sera disponible
            ],
            backgroundColor: ["#FD5B00", "#4AB0FE", "#BF09FF", "#FDD500"],
            hoverOffset: 4,
          },
        ],
      };

      setChartData(newData);
      setIsButtonVisible(false);
      setShowBaremeResult(true);
    }
  };

  const consommationAnnuelle =
    formData.depenseChauffage +
    formData.depenseECS +
    formData.depenseMenager +
    formData.depenseEclairage;

  const icons = {
    chauffage: { Picto1 },
    eauChaude: { Picto2 },
    appareils: { Picto3 },
    eclairage: { Picto4 },
  };
  
  formData.consoAnnuelle = consommationAnnuelle
  
  const baremeAideTable = {
    1: { bleu: 24031, jaune: 29253, violet: 40851, rose: 40852 },
    2: { bleu: 35270, jaune: 42933, violet: 60051, rose: 60052 },
    3: { bleu: 42357, jaune: 51564, violet: 71846, rose: 71847 },
    4: { bleu: 49455, jaune: 60208, violet: 84562, rose: 84563 },
    5: { bleu: 56580, jaune: 68877, violet: 96817, rose: 96818 },
    6: { bleu: 63696, jaune: 77540, violet: 109074, rose: 109075 },
    7: { bleu: 70812, jaune: 86203, violet: 121331, rose: 121332 },
    8: { bleu: 77928, jaune: 94866, violet: 133588, rose: 133589 },
    9: { bleu: 85044, jaune: 103529, violet: 145845, rose: 145846 },
    10: { bleu: 92160, jaune: 112192, violet: 158102, rose: 158103 },
  };

  const baremeAideTableProvince = {
    1: { bleu: 17363, jaune: 22259, violet: 31185, rose: 31186 },
    2: { bleu: 25393, jaune: 32553, violet: 45842, rose: 45843 },
    3: { bleu: 30540, jaune: 39148, violet: 55196, rose: 55197 },
    4: { bleu: 35676, jaune: 45735, violet: 64550, rose: 64551 },
    5: { bleu: 40835, jaune: 52348, violet: 73907, rose: 73908 },
    6: { bleu: 45986, jaune: 58946, violet: 83264, rose: 83265 },
    7: { bleu: 51137, jaune: 65544, violet: 92621, rose: 92622 },
    8: { bleu: 56288, jaune: 72142, violet: 101978, rose: 101979 },
    9: { bleu: 61439, jaune: 78740, violet: 111335, rose: 111336 },
    10: { bleu: 66590, jaune: 85338, violet: 120692, rose: 120693 },
  };

  const revenuFiscal = formData.revenuFiscal;
  const numberOfOccupants = formData.numberOfOccupants;
  const factureElectricite = formData.factureElectricite;
  const typeChauffage = formData.sourceType;
  const productionECS = formData.energieType;
  const factureSecondaire = formData.factureSecondaire;
  const departement = formData.departement;
  const altitude = formData.altitude;

  formData.consommationElectrique = factureElectricite / 0.17;

  const getAideColor = () => {
    console.log(formData.consoAnnuelle);
    const baremeAideTableToUse =
      formData.provinceOuIdf === "Ile de France"
        ? baremeAideTable
        : baremeAideTableProvince;

    const aides = baremeAideTableToUse[numberOfOccupants] || {};

    if (revenuFiscal < aides.bleu) {
      return "bleu";
    } else if (revenuFiscal < aides.jaune) {
      return "jaune";
    } else if (revenuFiscal < aides.violet) {
      return "violet";
    } else {
      return "rose";
    }
  };

  formData.aideColor = getAideColor(numberOfOccupants, revenuFiscal);
  const colorScheme = {
    bleu: "bleu",
    jaune: "jaune",
    violet: "violet",
    rose: "rose",
  };

  // const calculateDepenseEclairage = () => {
  //   return formData.factureElectricite * 0.1;
  // };

  // // Exemple d'utilisation
  // formData.depenseEclairage = calculateDepenseEclairage(
  //   formData.factureElectricite
  // );

  useEffect(() => {
    if (formData) {
      generateChartData(); // Assurez-vous que cette fonction ne s'exécute que lorsque formData est défini
    }
  }, [formData]); // Dépendance à formData pour ré-exécuter lorsque formData change

  return (
    <Box width="full" px={20}>
      <Box display={"flex"} flexDirection={"row"}>
        <Box display={"flex"} flexDirection={"column"}>
          <Heading fontSize={"28px"} mb={1} fontWeight={"510"}>
            Consommations poste par poste
          </Heading>
          <Text mb={8} color="#8C8C8C" fontWeight={"400"} fontSize="20px">
            Répartition de la consommation énergétique
          </Text>
        </Box>
        <Button
          ml={"58%"}
          w="120px"
          bgColor={"white"}
          color={"#30C9FF"}
          fontWeight={"600"}
          borderRadius={"8px"}
          padding={"8px, 16px, 8px, 21px"}
          onClick={onBack}
        >
          Back
        </Button>
      </Box>
      <Flex
        direction={{ base: "column", md: "row" }}
        border="1.8px solid"
        p={{ base: "30px", md: "30px 86px" }}
        gap="71px"
        borderRadius="8px"
        bg="#FCFDFF"
        align="center"
        borderColor={"#F4F4F4"}
        bgColor={"white"}
      >
        <Box display={"flex"} flexDirection={"column"}>
          <Box display={"flex"} flexDirection={"row"}>
            <Box display={"flex"} mr={"23.5%"} flexDirection={"column"}>
              <Heading
                fontSize={"20px"}
                fontWeight={"510"}
                color="gray.700"
                mb={1}
              >
                Vos consommations
              </Heading>
              <Text fontSize="17px" fontWeight={"400"} color="#8C8C8C" mb={8}>
                Résultat de vos consomations poste par poste
              </Text>
            </Box>{" "}
            <Box display={"flex"} flexDirection={"column"}>
              <Heading
                fontSize={"20px"}
                fontWeight={"510"}
                color="gray.700"
                mb={1}
              >
                Résultat Graphique
              </Heading>

              {/* <Text fontSize="17px" fontWeight={"400"} color="#8C8C8C">
                Résultat de consommation poste par poste
              </Text> */}
            </Box>
          </Box>
          <Box display="flex" flexDirection="row" alignItems="center">
            <Box flex="1" mr={["55px", "55px", "85px", "55px"]}>
              <SimpleGrid
                mb="30px"
                columns={2}
                spacingY={["60px", "60px", "30px", "60px"]}
                spacingX={["60px", "60px", "100px", "60px"]}
              >
                <ConsoCard
                  title="CHAUFFAGE"
                  amount={
                    formData.depenseChauffage
                      ? formData.depenseChauffage.toFixed(0)
                      : "N/A"
                  }
                  icon={Picto1}
                  bgColor="#a5bbd4"
                />
                <ConsoCard
                  title="EAU CHAUDE SANITAIRE"
                  amount={
                    formData.depenseECS ? formData.depenseECS.toFixed(0) : "N/A"
                  }
                  icon={Picto2}
                  bgColor="#15af97"
                />
                <ConsoCard
                  title="APPAREILS ÉLECTRIQUES"
                  amount={
                    formData.depenseMenager
                      ? formData.depenseMenager.toFixed(0)
                      : "N/A"
                  }
                  icon={Picto3}
                  bgColor="#0b816e"
                />
                <ConsoCard
                  title="ÉCLAIRAGE"
                  amount={
                    formData.depenseEclairage
                      ? formData.depenseEclairage.toFixed(0)
                      : "N/A"
                  }
                  icon={Picto4}
                  bgColor="#0e8a9f"
                />
              </SimpleGrid>
            </Box>
            <Divider
              orientation="vertical"
              border="1px solid"
              h="480px"
              color="#EAEAEA"
              mx={["45px", "45px", "35px", "45px"]}
            />
            <Box
              mb={"30px"}
              flex="1"
              display="flex"
              w={["400px", "400px", "200px", "400px"]}
              h="516px"
              flexDirection="column"
              alignItems="center" // Assure le centrage horizontal
              gap="10px"
              borderRadius="20px"
              padding="10px 10px 20px 10px"
              borderWidth="1px"
            >
              <Box
                boxSize={["450px", "450px", "320px", "450px"]}
                borderRadius="20px"
                p="4"
                rounded="md"
                bg="#F7F9FE"
              >
                {chartData && <Doughnut data={chartData} options={options} />}
              </Box>
              <Box>
                <Box
                  display={"flex"}
                  fontSize="15px"
                  fontWeight={"semibold"}
                  color={"#737373"}
                  flexDirection={"row"}
                >
                  <Text mr={["76%", "76%", "56%", "76%"]}>Label</Text>
                  <Text>Account</Text>
                </Box>
                <Divider w={["402px", "402px", "302px", "402px"]} my={"5px"} />
                <Box display="flex" alignItems="center" mt={2}>
                  <Image src={Picto5} boxSize="8px" mr={2} />
                  <Text
                    color="#737373"
                    fontSize={"15px"}
                    fontWeight={450}
                    flex="1"
                  >
                    CHAUFFAGE
                  </Text>
                  <Text fontWeight="440">
                    {formData.depenseChauffage?.toFixed(0)}€
                  </Text>
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                  <Image src={Picto6} boxSize="8px" mr={2} />
                  <Text
                    color="#737373"
                    fontSize={"15px"}
                    fontWeight={450}
                    flex="1"
                  >
                    EAU CHAUDE SANITAIRE
                  </Text>
                  <Text fontWeight="440">
                    {formData.depenseECS?.toFixed(0)}€
                  </Text>
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                  <Image src={Picto7} boxSize="8px" mr={2} />
                  <Text
                    color="#737373"
                    fontSize={"15px"}
                    fontWeight={450}
                    flex="1"
                  >
                    APPAREILS ÉLECTRIQUES
                  </Text>
                  <Text fontWeight="440">
                    {formData.depenseMenager?.toFixed(0)}€
                  </Text>
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                  <Image src={Picto8} boxSize="8px" mr={2} />
                  <Text
                    color="#737373"
                    fontSize={"15px"}
                    fontWeight={450}
                    flex="1"
                  >
                    ÉCLAIRAGE
                  </Text>
                  <Text fontWeight="440">
                    {formData.depenseEclairage?.toFixed(0)}€
                  </Text>
                </Box>
                <Divider w={["402px", "402px", "302px", "402px"]} my={"5px"} />
                <Box display="flex" alignItems="center" mt={2}>
                  <Text
                    color="#737373"
                    fontSize={"17px"}
                    fontWeight={500}
                    flex="1"
                  >
                    Consommation Annuelle
                  </Text>
                  <Text fontWeight="440">
                    {consommationAnnuelle.toFixed(0)}€
                  </Text>
                </Box>
                <Box display="flex" alignItems="center" mt={2}>
                  <Text
                    color="#737373"
                    fontSize={"17px"}
                    fontWeight={500}
                    flex="1"
                  >
                    Bareme Aide
                  </Text>
                  <Text fontWeight="440">{formData.aideColor}</Text>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Flex>
      <Flex justifyContent="flex-end" my="3%">
        <Button
          w="238px"
          bgColor="#30C9FF"
          color="#FCFDFF"
          borderRadius="8px"
          padding="8px 16px"
          onClick={onNext}
        >
          Confirmez les informations
        </Button>
      </Flex>
    </Box>
  );
};

export default StepSeven;
